export enum SenderIdType {
    Unknown = 'UNKNOWN',
    Cpr = 'CPR',
    Cvr = 'CVR',
}
